export default __webpack_public_path__ + "static/media/warning.c8439aad.svg";